export const url_app_android =
    'https://play.google.com/store/apps/details?id=com.iconosquare.appandroid';
export const url_app_ios = 'https://apps.apple.com/us/app/iconosquare-companion-app/id6744056528';
